export default __webpack_public_path__ + "ad786fc922f916ac32c662a662317488.svg";